import { Popover, Row } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { chain } from "lodash";
import "./HotelLocationSearch.scss";
import { convertStringFromENVToArray } from "@utils/common";
import { Col } from "antd4";

const HotelLocationSearch = ({
  value,
  startPointName,
  options,
  onChange,
  placeholder,
  onVisibleChange,
}) => {
  const [data, setData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const groupLocationsByOrder = (locations, locationGroups) => {
    const grouped = [];

    const groupHotels = chain(locations)
      .groupBy((x) => x.locationId)
      .map((items, key) => {
        const location = locations.find(
          (y) => y.locationId === key && y.type === "Location"
        );
        return {
          ...location,
          hotels: items.filter((x) => x.hotelName),
        };
      })
      .value();

    (locationGroups || []).forEach((group) => {
      const locations = groupHotels.filter((location) =>
        group.includes(location.locationId)
      );
      grouped.push(locations);
    });

    return grouped;
  };
  useEffect(() => {
    if (options.length === 0) return;
    const groupLocations = groupLocationsByOrder(
      options,
      convertStringFromENVToArray(
        process.env.REACT_APP_DISPLAYED_HOTEL_LOCATIONS
      ) || []
    );
    setData(groupLocations);
  }, [options]);

  // useEffect(() => {
  //   const groupHotels = chain(options)
  //     .groupBy((x) => x.locationId)
  //     .map((items, key) => {
  //       const location = options.find(
  //         (y) => y.locationId === key && y.type === "Location"
  //       );
  //       return {
  //         ...location,
  //         hotels: items.filter((x) => x.hotelName),
  //       };
  //     })
  //     .value();

  //   if (groupHotels?.length > 4) {
  //     groupHotels[2]["subGroup"] = [groupHotels[4]];
  //     groupHotels.splice(4, 1);
  //   }
  //   console.log(groupHotels);
  //   setData(groupHotels);
  // }, [options]);

  const handleSelectLocation = (item) => {
    onChange(item);
    setIsOpen(false);
  };

  const handleVisibleChange = (e) => {
    setIsOpen(e);
    if (onVisibleChange) {
      onVisibleChange(e);
    }
  };

  const renderItem = (l, index) => {
    return (
      <div key={index} className="location-col">
        {l.map((item, index) => (
          <div style={{ marginBottom: "20px" }}>
            <div
              className="location-name"
              onClick={() => handleSelectLocation(item)}
            >
              <img
                src={
                  require("@assets/include/svg/s43/fi-rr-marker.svg").default
                }
                className="g-mr-6"
                alt=""
              />
              <span>{item.locationName}</span>
            </div>
            <div className="hotel-list">
              {item.hotels.map((h, i) => (
                <div
                  key={i}
                  className="hotel-name"
                  onClick={() => handleSelectLocation(h)}
                >
                  {h.hotelName}
                </div>
              ))}
            </div>
            {item.subGroup?.length && item.subGroup.map((s) => renderItem(s, index))}
          </div>
        ))}
      </div>
    );
  };

  const content = useMemo(() => {
    return (
      <div className="s43-hotel-localtion-container">
        {data.map((l, index) => renderItem(l, index))}
      </div>
    );
  }, [data]);
  return (
    <Popover
      overlayClassName="hotel-localtion-popover"
      placement="bottomLeft"
      content={content}
      trigger="click"
      visible={isOpen}
      onVisibleChange={handleVisibleChange}
    >
      {value ? (
        <div className="hotel-overlay">
          {value.hotelName || value.locationName || startPointName}
        </div>
      ) : (
        <div
          style={{
            cursor: "pointer",
            color: "rgb(128,128,128,0.6)",
            fontWeight: "normal",
          }}
        >
          {placeholder}
        </div>
      )}
    </Popover>
  );
};

export default HotelLocationSearch;
